export class RemovePageAction {
  public static readonly type = '[Project/Wiki/List] RemovePageAction';
  constructor(public readonly id: string) {}
}
